/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/productMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a Product. */
export class Product {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a Product.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.ProductAllResponse>
   */
  all(options?: Models.ProductAllOptionalParams): Promise<Models.ProductAllResponse>;
  /**
   * @param callback The callback
   */
  all(callback: msRest.ServiceCallback<Models.ProductDto>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  all(options: Models.ProductAllOptionalParams, callback: msRest.ServiceCallback<Models.ProductDto>): void;
  all(options?: Models.ProductAllOptionalParams | msRest.ServiceCallback<Models.ProductDto>, callback?: msRest.ServiceCallback<Models.ProductDto>): Promise<Models.ProductAllResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allOperationSpec,
      callback) as Promise<Models.ProductAllResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const allOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "product/Product",
  queryParameters: [
    Parameters.filters,
    Parameters.sorts,
    Parameters.page,
    Parameters.pageSize,
    Parameters.selectedIds
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ProductDto
    },
    default: {}
  },
  serializer
};
